import * as React from 'react'
import { TableIcon } from '@radix-ui/react-icons'
import { ToolbarToggleItem } from '@radix-ui/react-toolbar'
import { Editor } from '@tiptap/react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/sotano-kit/primitives/dropdown-menu'
import { $toggleItem } from '..'
import { clsx } from 'clsx'
import { IconButton } from '~/sotano-kit/primitives/icon-button'

const getTableMenuActions = ({ editor }: { editor: Editor }) => [
  {
    name: 'Add Column Before',
    action: () => editor.chain().focus().addColumnBefore().run(),
  },
  {
    name: 'Add Column After',
    action: () => editor.chain().focus().addColumnAfter().run(),
  },
  {
    name: 'Delete Column',
    action: () => editor.chain().focus().deleteColumn().run(),
  },
  {
    name: 'Add Row Before',
    action: () => editor.chain().focus().addRowBefore().run(),
  },
  {
    name: 'Add Row After',
    action: () => editor.chain().focus().addRowAfter().run(),
  },
  {
    name: 'Delete Row',
    action: () => editor.chain().focus().deleteRow().run(),
  },
  {
    name: 'Delete Table',
    action: () => editor.chain().focus().deleteTable().run(),
  },
  {
    name: 'Merge Cells',
    action: () => editor.chain().focus().mergeCells().run(),
  },
  {
    name: 'Toggle Header Column',
    action: () => editor.chain().focus().toggleHeaderColumn().run(),
  },
  {
    name: 'Toggle Header Row',
    action: () => editor.chain().focus().toggleHeaderRow().run(),
  },
  {
    name: 'Toggle Header Cell',
    action: () => editor.chain().focus().toggleHeaderCell().run(),
  },
  {
    name: 'Merge Or Split',
    action: () => editor.chain().focus().mergeOrSplit().run(),
  },
]

export const TableActions = ({
  editor,
  containerElement,
  blockId,
}: {
  editor: Editor
  containerElement?: React.RefObject<HTMLElement | null>
  blockId: string
}) => {
  const actions = getTableMenuActions({ editor })

  return (
    <DropdownMenu aria-label="Hierarchy" modal={false}>
      <DropdownMenuTrigger asChild>
        <ToolbarToggleItem
          value="Table"
          className={$toggleItem({
            active: false,
            className: 'flex items-center space-x-2 w-auto',
          })}
        >
          <IconButton>
            <TableIcon className="w-3 h-3" />
          </IconButton>
        </ToolbarToggleItem>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        data-rt-editor-popover-id={blockId}
        onCloseAutoFocus={(e) => {
          e.preventDefault()
        }}
        collisionPadding={{
          top: 90,
        }}
        sideOffset={8}
        align="start"
        side="top"
        container={containerElement?.current}
        className="space-y-0.5"
      >
        {actions.map(({ action, name }) => (
          <DropdownMenuItem key={name} onClick={action}>
            <span className={clsx('flex items-center text-xs gap-2')}>
              {name}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
